import axios from '@/api/config';

const agentUserInfo = {
  getAgentUserInfoById(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserInfo/` + data, {});
  },
  getAgentUserInfo(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserInfo`, {params: data});
   },
  getAgentUserInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserInfoList`, {params: data});
  },
  getAgentUserInfoTree(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserInfoTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/pageList`, data);
  },
  addAgentUserInfo(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/addAgentUserInfo`, data);
  },
  updateAgentUserInfo(data) {
    return axios.put(`${process.env.BASE_URL}/agentUserInfo/updateAgentUserInfo`, data);
  },
  deleteAgentUserInfo(data) {
    return axios.delete(`${process.env.BASE_URL}/agentUserInfo/deleteAgentUserInfo`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/exportExcel`, {params: data});
  },
  getAgentInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentInfoList`, {params: data});
  },
  getAgentAmountStatsDTO(data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentAmountStatsDTO`, {params: data});
  },
  getAgentAmount(data) {
    return axios.get(`${process.env.BASE_URL}/agentInfo/getAgentAmount`, {params: data});
  },
  getAgentUserAmountStats(data) {
    return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentUserAmountStats`, {params: data});
  },
  enabledUser(data) {
    return axios.post(`${process.env.BASE_URL}//agentUserInfo/enabledUser`, data);
  },
  agentAmountLogPageList(data) {
    return axios.post(`${process.env.BASE_URL}/agentAmountLog/pageList`, data);
  },
  resetPassword(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/resetPassword`, data);
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/agentUserInfo/importData`, data);
  }
}

export default agentUserInfo;



// WEBPACK FOOTER //
// ./src/api/agentUserInfo.js